const cachios = require('cachios');
const axios = require('axios');

// Always call the API same-origin. In production Caddy proxies /api, /app,
// /login (etc.) to the portal API; in dev vue.config.js's devServer.proxy does
// the same. Sniffing location.hostname (the old approach) 404'd on every
// hostname that wasn't literally "localhost" — e.g. app.tennis.lan — because
// requests self-referenced the SPA host with nothing proxying them (TEN-120).
let url = '/'

const axiosInstance = axios.create({
    baseURL: url
});

import axiosRetry from 'axios-retry';

axiosRetry(axiosInstance, {
    retries: 10,
    retryDelay: axiosRetry.exponentialDelay
});

// all requests will now use this axios instance
const client = cachios.create(axiosInstance, {
    stdTTL: 120
});

export {client, axiosInstance, url};
